module.exports = __webpack_public_path__ + "static/awards_bg_mobile-82cd617fb172051f690ca2f3363a2bb8.svg";